import { boolean, InferType, object, string } from "yup";

export type IFormularioNexaasSchema = InferType<typeof formNexaasSchema>;

export const formNexaasSchema = object({
  date: string().required(),
  empresa: string().required(),
  selecionarPeriodo: boolean().required(),
  inicio: string().nullable(),
  fim: string().nullable()
});
